




















import Vue from 'vue';
import Sex from './Sex.vue';
import Language from './Language.vue';
import China from './China.vue';
import Province from './Province.vue';
import Subscribe from './Subscribe.vue';
import Score from './Score.vue';
import Interactive from './Interactive.vue';

export default Vue.extend({
  components: {
    Sex,
    Language,
    China,
    Province,
    Subscribe,
    Score,
    Interactive,
  },
});

